// src/supabaseClient.js
import { createClient } from "@supabase/supabase-js";

const supabaseUrl = "https://hrwiojrtliievuqispjq.supabase.co";
const supabaseKey =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imhyd2lvanJ0bGlpZXZ1cWlzcGpxIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTE4ODA4MTgsImV4cCI6MjA2NzQ1NjgxOH0.kASBX01OnkQmFJDJPoSkQ0eRPs2RSXznoqOVfeXXA-k";

export const supabase = createClient(supabaseUrl, supabaseKey);
